/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import {
  LagoPaymentMethod, PaymentMethod, PaymentMethodData, PaymentMethodsState,
} from './types';
import { MutationRequestState, MutationRequestStatus } from '../types';
import { getDefaultErrorState, getDefaultLoadingState, getDefaultState } from '../utils';
import { BaseMoney } from '../price/types';

export const mutations: MutationTree<PaymentMethodsState> = {
  // Checkout payment methdos
  checkoutMethodsLoading: (state) => state.checkoutMethods = { ...getDefaultLoadingState() },
  checkoutMethodsLoaded: (state, payload: PaymentMethodData) => {
    state.checkoutMethods = {
      error: undefined,
      status: MutationRequestStatus.SUCCESS,
      data: payload,
    };

    state.sdk = payload.sdk;
  },
  checkoutMethodsError: (state) => state.checkoutMethods = { ...getDefaultErrorState() },

  // Save Payment Method Modal Methods
  setupMethodsLoading: (state) => state.setupMethods = { ...getDefaultLoadingState() },
  setupMethodsLoaded: (state, payload: PaymentMethodData) => {
    state.setupMethods = {
      error: undefined,
      status: MutationRequestStatus.SUCCESS,
      data: payload,
    };

    state.sdk = payload.sdk;
  },
  setupMethodsError: (state) => state.setupMethods = { ...getDefaultErrorState() },

  // Recharge Modal Methods
  rechargeMethodsLoading: (state) => state.rechargeMethods = { ...getDefaultLoadingState() },
  rechargeMethodsLoaded: (state, payload: PaymentMethodData) => {
    state.rechargeMethods = {
      error: undefined,
      status: MutationRequestStatus.SUCCESS,
      data: payload,
    };

    state.sdk = payload.sdk;
  },
  rechargeMethodsError: (state) => state.rechargeMethods = { ...getDefaultErrorState() },

  // @deprecated: most likely deprecated
  paymentMethodsLoaded(state, payload: PaymentMethodData) {
    state.error = false;
    state.paymentMethods = {
      status: MutationRequestStatus.SUCCESS,
      data: payload,
      error: undefined,
    };
  },
  paymentMethodsError(state) {
    state.paymentMethods = { ...getDefaultErrorState() };
  },
  preferableAmountLoading:
    (state) => state.preferableTransactionAmount = { ...getDefaultLoadingState() },
  preferableAmountLoaded: (state, payload: BaseMoney) => {
    state.preferableTransactionAmount = {
      status: MutationRequestStatus.SUCCESS,
      data: payload,
      error: undefined,
    };
  },
  preferableAmountError:
    (state) => state.preferableTransactionAmount = { ...getDefaultErrorState() },

  // Adyen SPM
  adyenSPMLoading: (state) => state.adyenSPM = { ...getDefaultLoadingState() },
  adyenSPMLoaded: (state, payload: PaymentMethod) => {
    state.adyenSPM = {
      status: MutationRequestStatus.SUCCESS,
      data: payload,
      error: undefined,
    };
  },
  adyenSPMError: (state) => state.adyenSPM = { ...getDefaultErrorState() },

  // Lago Payment Methods
  setLagoPaymentMethods:
    (
      state: PaymentMethodsState,
      payload: Array<LagoPaymentMethod>,
    ) => state.lagoPaymentMethods = payload,

  deleteLagoPaymentMethod:
    (
      state: PaymentMethodsState,
      payload: string,
    ) => state.lagoPaymentMethods = state.lagoPaymentMethods
      .filter((method) => method.id !== payload),

  setDefaultLagoPaymentMethod:
    (
      state: PaymentMethodsState,
      payload: string,
    ) => state.lagoDefaultPaymentMethod = payload,
};
